var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto max-w-xl relative min-h-screen",attrs:{"id":"app"}},[(_vm.isUpdating)?_c('div',{staticClass:"fixed top-0 left-0 w-full p-2 text-white bg-primary z-50"},[_vm._v(" New Version available. Update in "+_vm._s(_vm.countdown)+" seconds ")]):_vm._e(),_c('LegalReminderComp'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }